export const ErrorElement = () => {
  return (
    <section>
      <div className="container herosub">
        <h1>Something went wrong</h1>
        <h2>
          Please contact support at{" "}
          <a href="mailto:support@tiltify.com">support@tiltify.com</a>
        </h2>
      </div>
    </section>
  );
};
